import { CALL_API, Schemas } from '../../../common/middleware/api';

export const MELILLO_CHILD_DETAILS_FETCH_REQUEST = 'MELILLO_CHILD_DETAILS_FETCH_REQUEST';
export const MELILLO_CHILD_DETAILS_FETCH_SUCCESS = 'MELILLO_CHILD_DETAILS_FETCH_SUCCESS';
export const MELILLO_CHILD_DETAILS_FETCH_FAILURE = 'MELILLO_CHILD_DETAILS_FETCH_FAILURE';

export const fetchChildDetails = (childId) => ({
	[CALL_API]: {
		types: [MELILLO_CHILD_DETAILS_FETCH_REQUEST, MELILLO_CHILD_DETAILS_FETCH_SUCCESS, MELILLO_CHILD_DETAILS_FETCH_FAILURE],
		endpoint: `api/integrations/melillo/children/${childId}`,
		schema: Schemas.CHILD
	}
});